/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState, useEffect } from 'react';
// redux
import { useDispatch, useSelector } from 'react-redux'
import { getAddOns, getCommentsCounterCode } from '../../../../../state/thunks/commenting';
// utils
// material
import ExpandableSection from '../../../../../material/expandablesection/expandablesection';
import ConfigController from '../../../../../material/expandablesection/controllers/configcontroller/configcontroller';
// content
import CommentsCounterSection from './commentscountersection/commentscountersection';
import CommunitySection from './communitysection/communitysection';
// styles
import injectSheet from "react-jss";
import styles from './addons_styles';


/* ========== ~~~~~~~~~~ COMMENTING ADVANCED: ADDONS SECTION ~~~~~~~~~~ ========== */
const CommentingAddOnsSection = injectSheet(styles)((props) => {
  const dispatch = useDispatch()

  const { siteUUID } = useSelector((state) => state.session);
  const isPageIDEnabled = useSelector((state => state.commenting.commentingConfig?.data?.general?.isPageIDEnabled));

  const [isOpened, setIsOpened] = useState(false);

    // TODO: Remove this when addons got moved from configuration page
    const [init,setInit] = useState(false); // flag for fetching comments counter code and setting initial label fields

    useEffect(() => {
      // TODO: Remove this when addons got moved from configuration page
      // fetch comments counter code when general isPageIDEnabled setting got updated
      if(init) dispatch(getCommentsCounterCode({siteUUID}))
    }, [isPageIDEnabled])

  useEffect(() => {
    if(siteUUID) {
      dispatch(getAddOns({siteUUID}))
      setInit(true)
    }
  }, [])


  const handleToggle = () => setIsOpened(!isOpened) 

  const controller = (
    <ConfigController
      handleToggle={handleToggle}
      handleCancel={handleToggle}
      isOpened={isOpened}
      configTitle={'View'}
      cancelTitle={'Close'}
      title='Add Ons'
    />
  );
  
  return (
    <ExpandableSection
      className={`commentingaddonssection ${props.classes.commentingaddonssection}`}
      controller={controller}
      isOpened={isOpened}
      handleCancel={handleToggle}
      cancelTitle={'Close'}
    >
    {isOpened && 
      <div className={`addons ${props.classes.addons}`}>
        <CommentsCounterSection />
        <CommunitySection />
      </div>
    }
    </ExpandableSection>
  );
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default CommentingAddOnsSection